import AnalyticsListener from "../../components/AnalyticsListener.jsx";
import SiteRoutes from "./SiteRoutes.jsx";

export default function App() {
  return (
    <>
      <AnalyticsListener />
      <SiteRoutes />
    </>
  );
}